import React from "react"

import { Button, Stack } from "@mui/material"

import { useSelector } from "react-redux"


import {
  getIsEditionReusableProductionStepSelector, getIsNewReusableProductionStepSelector,
  getReusableProductionStepSelector,
} from "../../../../../reducers/Steps/steps"
import MoreMenu from "../../../../../components/MoreMenu"
import { useMemo } from "react"

const ReusableStepFormRightAction = ({
  onCancel,
  onSubmit,
  menus = []
}) => {
  const isEdition = useSelector(getIsEditionReusableProductionStepSelector)
  const isNew = useSelector(getIsNewReusableProductionStepSelector)
  const reusableStep = useSelector(getReusableProductionStepSelector)

  const options = useMemo(() => {
    // if no reusable step, it means we are in creation mode, so we show all options
    if (reusableStep?.baseReusableProductionStep) {
      return menus.filter(menu => menu.key !== "option")
    }
    return menus
  }, [menus, reusableStep])


  if (isEdition || isNew) {
    return (
      <Stack direction="row" spacing={5}>
        <Button onClick={onCancel}>Annuler</Button>
        <Button onClick={onSubmit} variant="contained">Enregistrer</Button>
      </Stack>
    )
  }

  return (
    <Stack direction="row" spacing={5}>
      <MoreMenu
        menus={options}
      />
    </Stack>
  )
}

export default ReusableStepFormRightAction
